<script setup lang="ts">
import { firebaseAnalytics } from "../infra/firebase/firebaseAnalytics/firebase-analytics-helper";
import AppHeader from "@/components/AppHeader.vue";
import { setup3rdPartyScripts } from "~/utils/internet/setup-3rd-party-scripts";

useLandingHead();

const env = useRuntimeConfig();

onMounted(() => {
  if (process.client && env.public.stage === "prod") {
    firebaseAnalytics();
    setup3rdPartyScripts();
  }
});
</script>
<template>
  <div>
    <AppHeader />
    <main>
      <suspense>
        <slot></slot>
      </suspense>
    </main>
    <NuxtIsland name="AppFooter" />
  </div>
</template>
